// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-4340a8f6]{display:flex;flex-direction:column;height:100vh;overflow:auto;min-width:1200px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
